import {InputText} from 'primereact/inputtext';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import MenuItemIcon from '../MenuItemIcon';

class InputTextComponent extends Component {
    renderView() {
        const {
            colClass,
            formGroup,
            iconColor,
            iconName,
            iconSide,
            iconSize,
            iconSvg,
            id,
            insideTable,
            label,
            objectId,
            renderValue,
            renderLabel,
            showLabel,
            titleElement,
            titleElementClass,
            titleElementShowId,
            value,
            validateViewMode,
            validator,
            validators,
            idForViewValidation,
        } = this.props;
        return (
            <div className={insideTable ? '' : titleElement ? titleElementClass : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : `col-md-12 ${formGroup ? 'form-group' : ''}`}>
                        {renderLabel ? (
                            renderLabel()
                        ) : label !== undefined && showLabel && !titleElement ? (
                            <label
                                id={idForViewValidation ? `${id}` : `${id}-label-id`}
                                className='p-label'
                                htmlFor={id}
                                style={{width: '100%'}}
                            >
                                {label}
                            </label>
                        ) : null}
                        <span
                            id={id}
                            aria-label={label}
                            aria-labelledby={`${id}-label-id`}
                            className={`p-inputtext-view icon_text ${titleElement ? ' title-element' : ''} ${
                                iconName !== undefined ? iconColor : ''
                            }`}
                        >
                            <span className='p-inputtext-view-content'>
                                {iconSide === 'left' && iconName !== undefined ? (
                                    <i className={`icon mdi ${iconName} ${iconSize}`} />
                                ) : null}
                                {iconSide === 'left' && iconSvg !== undefined ? (
                                    <MenuItemIcon alt='' className={`icon-svg ${iconSize}`} iconSvg={iconSvg} />
                                ) : null}
                                {renderValue ? renderValue() : value}
                                {iconSide === 'right' && iconName !== undefined ? (
                                    <i className={`icon mdi ${iconName} ${iconSize}`} />
                                ) : null}
                            </span>
                        </span>
                        {titleElement && titleElementShowId ? <span className='p-inputtext-view'>{` ID: ${objectId}`}</span> : null}
                        {validateViewMode && validator ? validator.message(id, label, value, validators) : null}
                    </div>
                </div>
            </div>
        );
    }

    renderEdit() {
        return this.renderNew();
    }

    renderNew() {
        const {
            colClass,
            disabled,
            id,
            insideTable,
            keyfilter,
            label,
            max,
            name,
            onAfterStateChange,
            onChange,
            placeholder,
            showLabel,
            stateField,
            tooltip,
            validator,
            validators,
            value,
            renderLabel,
            onBlur,
            iconColor,
            iconName,
            iconSide,
            iconSize,
            iconSvg,
            onInput,
        } = this.props;
        const required = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
        return (
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {renderLabel ? (
                            renderLabel()
                        ) : label !== undefined && showLabel ? (
                            <label id={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {
                                    //(renderRequired === true ? <span>{label}<span className='text-danger'>*</span></span> : label) ||
                                    validators.includes('not_required') ? label : <label className='p-label'> {label}<label className='p-label-red'>{'*'}</label></label>   
                                }
                            </label>
                        ) : null}
                        <span className={`p-inputtext-view icon_text  ${iconName !== undefined ? iconColor : ''}`}>
                            {iconSide === 'left' && iconName !== undefined ? <i className={`icon mdi ${iconName} ${iconSize}`} /> : null}
                            {iconSide === 'left' && iconSvg !== undefined ? (
                                <MenuItemIcon alt='' className={`icon-svg ${iconSize}`} iconSvg={iconSvg} />
                            ) : null}

                            {iconSide === 'right' && iconName !== undefined ? <i className={`icon mdi ${iconName} ${iconSize}`} /> : null}
                        </span>
                        <InputText
                            aria-describedby={`${id}-error`}
                            aria-label={label}
                            aria-labelledby={label === undefined && showLabel ? `${id}-label-id` : undefined}
                            key={id}
                            id={id}
                            name={name}
                            max={max}
                            type='text'
                            keyfilter={keyfilter}
                            placeholder={placeholder}
                            style={{width: '100%'}}
                            value={value}
                            onChange={(e) => (onChange ? onChange('TEXT', undefined, e, onAfterStateChange, stateField) : null)}
                            onBlur={onBlur}
                            disabled={disabled}
                            required={required}
                            tooltip={tooltip}
                            onInput={onInput}
                        />
                        <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {rendered, viewMode} = this.props;
        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew();
                case 'EDIT':
                    return this.renderEdit();
                case 'VIEW':
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

InputTextComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    formGroup: true,
    iconSide: 'left',
    insideTable: false,
    max: 255,
    objectId: '',
    placeholder: '',
    rendered: true,
    showLabel: true,
    stateField: 'element',
    titleElement: false,
    titleElementShowId: false,
    titleElementClass: 'col-md-12',
    validateViewMode: false,
    validators: 'required',
    viewMode: 'VIEW',
    renderRequired: false,
    idForViewValidation: false,
};

InputTextComponent.propTypes = {
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    formGroup: PropTypes.bool,
    iconColor: PropTypes.string,
    iconName: PropTypes.string,
    iconSide: PropTypes.string,
    iconSize: PropTypes.string,
    iconSvg: PropTypes.string,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    keyfilter: PropTypes.string,
    label: PropTypes.string.isRequired,
    labelForValidator: PropTypes.string,
    max: PropTypes.number,
    name: PropTypes.string.isRequired,
    objectId: PropTypes.string,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    rendered: PropTypes.bool,
    showLabel: PropTypes.bool,
    stateField: PropTypes.string,
    titleElement: PropTypes.bool,
    titleElementClass: PropTypes.string,
    titleElementShowId: PropTypes.bool,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object.isRequired,
    validators: PropTypes.string,
    value: PropTypes.string,
    viewMode: PropTypes.string,
    renderLabel: PropTypes.func,
    onBlur: PropTypes.func,
    renderRequired: PropTypes.bool,
    idForViewValidation: PropTypes.bool,
};

export default withTranslation()(InputTextComponent);
